import Vue from 'vue'
import Router from 'vue-router'
import PageHome from '@/views/PageHome'
import PageAbout from '@/views/PageAbout'
import PageServices from '@/views/PageServices'
import PageBootcamp from '@/views/PageBootcamp'
import PageContact from '@/views/PageContact'
import PageBeAccountable from '@/views/PageBeAccountable'
import PageEatRight from '@/views/PageEatRight'
import PageWorkHard from '@/views/PageWorkHard'
import PageTestimonials from '@/views/PageTestimonials'
import PageNotFound from '@/views/PageNotFound'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: PageHome
    },
    {
      path: '/about',
      name: 'about',
      component: PageAbout
    },
    {
      path: '/services',
      name: 'services',
      component: PageServices
    },
    {
      path: '/bootcamp',
      name: 'bootcamp',
      component: PageBootcamp
    },
    {
      path: '/testimonials',
      name: 'testimonials',
      component: PageTestimonials
    },
    {
      path: '/contact',
      name: 'contact',
      component: PageContact
    },
    {
      path: '/be-accountable',
      name: 'be-accountable',
      component: PageBeAccountable
    },
    {
      path: '/eat-right',
      name: 'eat-right',
      component: PageEatRight
    },
    {
      path: '/work-hard',
      name: 'work-hard',
      component: PageWorkHard
    },
    {
      path: '*',
      name: 'not-found',
      component: PageNotFound
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      // savedPosition is only available for popstate navigations.
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  mode: 'history'
})
